import React,{useEffect} from "react";
import { InView } from 'react-intersection-observer'


const Test = () => {


    return (
        <div>
            <InView>
                {({ inView, ref, entry }) => (
                    <div ref={ref}>
                        <Component1 inView={inView}/>
                    </div>
                )}
            </InView>
            <InView>
                {({ inView, ref, entry }) => (
                    <div ref={ref}>
                        <Component2 inView={inView}/>
                    </div>
                )}
            </InView>
            <InView>
                {({ inView, ref, entry }) => (
                    <div ref={ref}>
                        <Component3 inView={inView}/>
                    </div>
                )}
            </InView>
            {/*<InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>*/}

            {/*            <Component1 />*/}

            {/*</InView>*/}
            {/*<InView as="div" onChange={(inView, entry) => console.log('Inview1:', inView)}>*/}

            {/*            <Component2 />*/}

            {/*</InView>*/}
            {/*<InView as="div" onChange={(inView, entry) => console.log('Inview2:', inView)}>*/}

            {/*    <Component3 />*/}

            {/*</InView>*/}
        </div>
    );
};

export default Test;

const Component1 = (props) => {
    console.log('Inview1:', props.inView)
    return(
        <div style={{width:"100%",height:"500px",backgroundColor:"red"}}>
            First-</div>
    )
}
const Component2 = (props) => {
    console.log('Inview2:', props.inView)

    return(
        <div style={{width:"100%",height:"500px",backgroundColor:"green"}}>Second-</div>
    )
}
const Component3 = (props) => {
    console.log('Inview3:', props.inView)

    return(
        <div style={{width:"100%",height:"500px",backgroundColor:"blue"}}>third-</div>
    )
}



